module.exports = "<p>未解决原因：</p> <ul class=em-taglist> <% _.each(tags, function(tag){ %> <li class=em-tag tagid=\"<%= tag.id %>\"><%= tag.name %></li> <% }) %> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/app/pages/main/chat/template/tagsTpl.html
// module id = 221
// module chunks = 0